import type { HarrisonApiDatasource } from '../datasources/harrison-api.datasource';
import type {
  CreateHarrisonPromptInput,
  CreatedHarrisonPrompt,
  HarrisonDraft,
  HarrisonModels,
  HarrisonPromptVersion,
} from '../../domain/entities/harrison.entity';

export class HarrisonRepositoryImpl {
  private readonly api: HarrisonApiDatasource;

  constructor(api: HarrisonApiDatasource) {
    this.api = api;
  }

  getModels(): Promise<HarrisonModels> {
    return this.api.getModels();
  }

  draftOfficialComment(
    questionId: string,
    model: string | undefined,
    signal?: AbortSignal,
  ): Promise<HarrisonDraft> {
    return this.api.draftOfficialComment(questionId, model, signal);
  }

  listPrompts(): Promise<HarrisonPromptVersion[]> {
    return this.api.listPrompts();
  }

  createPrompt(
    input: CreateHarrisonPromptInput,
  ): Promise<CreatedHarrisonPrompt> {
    return this.api.createPrompt(input);
  }

  makePromptDefault(versionId: string): Promise<HarrisonPromptVersion> {
    return this.api.makePromptDefault(versionId);
  }
}
